import {
  GET_COMPOSERS_START,
  GET_COMPOSERS_SUCCESS,
  GET_COMPOSERS_ERROR,
  CREATE_COMPOSER_START,
  CREATE_COMPOSER_SUCCESS,
  CREATE_COMPOSER_ERROR,
  DELETE_COMPOSER_START,
  DELETE_COMPOSER_SUCCESS,
  DELETE_COMPOSER_ERROR,
  EDIT_COMPOSER_START,
  EDIT_COMPOSER_SUCCESS,
  EDIT_COMPOSER_ERROR,
} from '../actions/composer/composer.actiontype';

export default function(state = { list: [] }, action) {
  switch (action.type) {
    case GET_COMPOSERS_START:
      return {
        ...state,
        isFetching: true,
      };
    case GET_COMPOSERS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        list: action.payload,
      };
    case GET_COMPOSERS_ERROR:
      return {
        ...state,
        isFetching: false,
      };
    case CREATE_COMPOSER_START:
      return {
        ...state,
        isCreating: true,
      };
    case CREATE_COMPOSER_SUCCESS:
      return {
        ...state,
        isCreating: false,
        list: [...state.list, action.payload],
      };
    case CREATE_COMPOSER_ERROR:
      return {
        ...state,
        isCreating: false,
      };
    case EDIT_COMPOSER_START:
      return {
        ...state,
        isCreating: true,
      };
    case EDIT_COMPOSER_SUCCESS:
      return {
        ...state,
        isCreating: false,
        list: state.list.map(composer => {
          if (composer.id === action.payload.id) {
            return action.payload;
          }
          return composer;
        }),
      };
    case EDIT_COMPOSER_ERROR:
      return {
        ...state,
        isCreating: false,
      };
    case DELETE_COMPOSER_START:
      return {
        ...state,
        isDeleting: true,
      };
    case DELETE_COMPOSER_SUCCESS:
      const newList = state.list.filter(composer => composer.id !== action.payload.id);
      return {
        ...state,
        isDeleting: false,
        list: newList,
      };
    case DELETE_COMPOSER_ERROR:
      return {
        ...state,
        isDeleting: false,
      };
    default:
      return state;
  }
}
